import(/* webpackMode: "eager" */ "/app/apps/backoffice-app/components/DndProviderWrapper.tsx");
import(/* webpackMode: "eager" */ "/app/apps/backoffice-app/styles/globals.css");
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/300.css");
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/400.css");
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/500.css");
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/600.css");
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/700.css");
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/800.css");
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/900.css")